import { openDB } from 'idb';

const DB_NAME = 'dinner-league-sync';
const DB_VERSION = 1;
const STORE_NAME = 'queue';

const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db) {
    db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
  },
});

export async function enqueue(type, payload) {
  const db = await dbPromise;
  await db.add(STORE_NAME, { type, payload, createdAt: Date.now() });
}

export async function pendingCount() {
  const db = await dbPromise;
  return db.count(STORE_NAME);
}

export async function replayQueue(supabase) {
  if (!supabase) return;
  const db = await dbPromise;
  const items = await db.getAll(STORE_NAME);

  for (const item of items) {
    try {
      if (item.type === 'swipe') {
        const { member_id, recipe_id, liked } = item.payload;
        const { error } = await supabase
          .from('preference_swipes')
          .upsert({ member_id, recipe_id, liked }, { onConflict: 'member_id,recipe_id' });
        if (error) continue; // leave for next retry
      } else if (item.type === 'feedback') {
        const { error } = await supabase
          .from('meal_feedback')
          .upsert(item.payload, { onConflict: 'meal_plan_id,recipe_id,member_id,day,meal' });
        if (error) continue;
      }
      await db.delete(STORE_NAME, item.id);
    } catch {
      // Network error — stop processing, retry on next online event
      break;
    }
  }
}
